import React from 'react';

const BlogHeader = () => {
    return (
        <div class="text-center">
            <h2
                class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
            >
                ALL BLOGS ARE HERE
            </h2>
            <p
                class="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4"
            >
                Lorem ipsum dolor sit amet consectetur, adipisicing
                elit. Ipsa libero labore natus atque, ducimus sed.
            </p>
        </div>
    );
};

export default BlogHeader;